import { CompletedIcon, PendingIcon } from "@/components/icons";
import clsx from "clsx";

export const StatusBadge = ({ status }: { status: boolean }) => {
  const config = status
    ? {
        label: "Terminé",
        icon: <CompletedIcon />,
        className: "font-black text-[9px] leading-4",
      }
    : {
        label: "En cours",
        icon: <PendingIcon />,
        className: "font-black text-[9px] leading-4",
      };

  return (
    <span className={clsx("inline-flex items-center gap-1 font-black text-xs", config.className)}>
      <span className="text-sm">{config.icon}</span>
      {config.label}
    </span>
  );
};
